import Vue from 'vue'
//import $ from 'jquery'
//import 'bootstrap/dist/css/bootstrap.min.css'
//import 'bootstrap/dist/js/bootstrap.min.js'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/css/font-awesome.css'
import './assets/css/style.css'
import 'swiper/dist/css/swiper.css';
import "babel-polyfill";
import App from './components/App.vue'

import Vuex from 'vuex'
import VueRouter from 'vue-router'

import HeaderVue from './components/Header.vue'
import modelVue from './components/model.vue'
import Login from './components/Login.vue'
// 数据中心
import Plate from './components/plate.vue'
import Plate2 from './components/plate2.vue'
import energyStatistics from './components/energyStatistics.vue'


import workbench from './components/workbench.vue'
import findpass from './components/findpass.vue'
import register from './components/register.vue'
import accountTransfer from './components/accountTransfer.vue'
import choosepeople from './components/choosepeople.vue'
import setmanager from './components/setmanager.vue'
import resetPass from './components/resetPass.vue'
import personalData from './components/personalData.vue'
import productManage from './components/productManage.vue'
import news from './components/news.vue'
import collectDevice from './components/device/collectDevice.vue'
import bindDevice from './components/device/bindDevice.vue'
import terminalDevice from './components/device/terminalDevice.vue'
import terminalDetail from './components/device/terminalDetail.vue'
import dataCenter from './components/device/dataCenter.vue'
import firewareUpdate from './components/device/firewareUpdate.vue'
import dataCenterDetail from './components/device/dataCenterDetail.vue'
import dataCenterDetailEnv from './components/device/dataCenterDetailEnv.vue'
//大型设备
import distributionMonitor from './components/device/distributionMonitor.vue'
import bigAirCondition from './components/device/bigAirCondition.vue'
import env from './components/device/env.vue'
import ups from './components/device/ups.vue'

import backgroundTerminal from './components/device/backgroundTerminal.vue'
import assetsManage from './components/device/assetsManage.vue'
import manufacturer from './components/device/manufacturer.vue'
import maintenance from './components/device/maintenance.vue'
import terminalProduct from './components/device/terminalProduct.vue'
import terminalModel from './components/device/terminalModel.vue'
import terminalModelDevice from './components/device/terminalModelDevice.vue'
import deviceGroup from './components/device/deviceGroup.vue'
import rightsHeader from './components/device/rightsHeader.vue'
import alarmStatistical from './components/alarm/alarmStatistical.vue'
import alarmList from './components/alarm/alarmList.vue'
import envLinkage from './components/alarm/envLinkage.vue'

import threshold from './components/alarm/threshold.vue'
import envThreshold from './components/alarm/envThreshold.vue'
import thresholdBatch from './components/alarm/thresholdBatch.vue'
import envThresholdBatch from './components/alarm/envThresholdBatch.vue'

import menuManage from './components/rightPanel/menuManage.vue'
import roleManage from './components/rightPanel/roleManage.vue'
import repairOrder from './components/rightPanel/repairOrder.vue'
import repairOrderPub from './components/rightPanel/repairOrderPub.vue'
import newOrder from './components/rightPanel/newOrder.vue'
import repairDetail from './components/rightPanel/repairDetail.vue'

import systemMsg from './components/systemMsg.vue'
import door from './components/door.vue'
import doorManager from './components/doorManager.vue'
import doorOperate from './components/doorOperate.vue'
import doorSwitch from './components/doorSwitch.vue'





Vue.use(ElementUI);
//状态管理
Vue.use(Vuex);
  //路由
Vue.use(VueRouter);

Vue.component("HeaderVue",HeaderVue);
Vue.component("modelVue",modelVue);
//Vue.component("Login",Login);


let sha256=require("js-sha256").sha256;

// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

//时间格式化
import moment from 'moment';
Vue.prototype.$moment = moment;

//引入axios
import axios from 'axios'
Vue.prototype.$ajax = axios

//请求接口处理参数
import qs from 'qs';
Vue.prototype.$qs = qs;

//加载效果
import Loading from "./components/loading/index"
Vue.use(Loading);


//路由配置
//如果需要加菜单，就在这里添加路由，并在UserMenu.vue添加入口router-link
const router = new VueRouter({
    routes: [{
        path: '/',
        component: Login
    },{
        path: '/login',
        component: Login
    }, {
        path: '/plate',
        component: Plate
    },
    {
        path: '/plate2',
        component: Plate2
    },
    {
        path: '/workbench',
        component: workbench
    },
    {
        path: '/findpass',
        component: findpass
    },  
    /*注册*/
    {
        path: '/register',
        component: register
    },
    /*公司选择相应人员 普通用户管理*/
    {
        path: '/choosepeople',
        component: choosepeople
    },
    /*设置公司管理员 管理员及用户管理*/
    {
        path: '/setmanager',
        component: setmanager
    },
    /*重置密码*/
    {
        path: '/resetPass',
        component: resetPass
    },
    /*账号移交*/
    {
        path: '/accountTransfer',
        component: accountTransfer
    },
    /*真实姓名变更*/
    {
        path: '/personalData',
        component: personalData
    },
    /*产品介绍及公司动态编辑添加*/
    {
        path: '/news',
        component: news
    },
    /*导航设置*/
    {
        path: '/productManage',
        component: productManage
    },
    /*告警统计*/
    {
        path: '/alarmStatistical',
        component: alarmStatistical
    },
    /*告警列表*/
    {
        path: '/alarm/alarmList',
        component: alarmList
    },
    /*单个阈值管理*/
    {
        path: '/alarm/threshold',
        component: threshold
    },
    /*动环单个阈值管理*/
    {
        path: '/alarm/envThreshold',
        component: envThreshold
    },
    /*系统消息*/
    {
        path: '/systemMsg',
        component: systemMsg
    },
    /*批量阈值管理*/
    {
        path: '/alarm/thresholdBatch',
        component: thresholdBatch
    },
    /*动环批量阈值管理*/
    {
        path: '/alarm/envThresholdBatch',
        component: envThresholdBatch
    },
    /*绑定设备*/
    {
        path: '/device/bindDevice',
        component: bindDevice
    },
    /*固件升级*/
    {
        path: '/device/firewareUpdate',
        component: firewareUpdate
    },
    /*采集设备管理*/
    {
        path: '/device/collectDevice',
        component: collectDevice
    },
    /*资产管理*/
    {
        path: '/device/assetsManage',
        component: assetsManage
    },
    /*厂商管理*/
    {
        path: '/device/manufacturer',
        component: manufacturer
    },
    /*维保单位*/
    {
        path: '/device/maintenance',
        component: maintenance
    },
    /*终端设备管理*/
    {
        path: '/device/terminalDevice',
        component: terminalDevice
    },
    /*终端类别*/
    {
        path: '/device/backgroundTerminal',
        component: backgroundTerminal
    },
    /*设备分组*/
    {
        path: '/device/deviceGroup',
        component: deviceGroup
    },
    /*历史数据页面1*/
    {
        path: '/device/dataCenter',
        component: dataCenter
    },
    /*机柜历史数据页面详情*/
    {
        path: '/device/dataCenterDetail',
        component: dataCenterDetail
    },
    /*动环历史数据页面详情*/
    {
        path: '/device/dataCenterDetailEnv',
        component: dataCenterDetailEnv
    },
    /*设备权限*/
    {
        path: '/device/rightsHeader',
        component: rightsHeader
    },
    /*终端产品*/
    {
        path: '/device/terminalProduct',
        component: terminalProduct
    },
    /*配电详情*/
    {
        path: '/device/distributionMonitor',
        component: distributionMonitor
    },
    /*大型空调*/
    {
        path: '/device/bigAirCondition',
        component: bigAirCondition
    },
    /*动环环境*/
    {
        path: '/device/env',
        component: env
    },
    /*UPS*/
    {
        path: '/device/ups',
        component: ups
    },
    /*菜单管理*/
    {
        path: '/rightPanel/menuManage',
        component: menuManage
    },
    /*角色管理*/
    {
        path: '/rightPanel/roleManage',
        component: roleManage
    },
    /*工单详情*/
    {
        path: '/rightPanel/repairDetail',
        component: repairDetail
    },
    /*终端设备详情*/
    {
        path: '/device/terminalDetail',
        component: terminalDetail
    },
    /*终端模板*/
    {
        path: '/device/terminalModel',
        component: terminalModel
    },
    /*终端模板终端详情*/
    {
        path: '/device/terminalModelDevice',
        component: terminalModelDevice
    },
    /*动环联动管理*/
    {
        path: '/alarm/envLinkage',
        component: envLinkage
    },
    /*巡检工单*/
    {
        path: '/repairOrder',
        component: repairOrder
    },
    /*公有云工单管理*/
    {
        path: '/repairOrderPub',
        component: repairOrderPub
    },
    /*门禁管理 指纹识别 人脸识别*/
    {
        path: '/door',
        component: door
    },
    // 指纹门禁人员
    {
        path: '/doorManager',
        component: doorManager
    },
    // 指纹门禁设备
    {
        path: '/doorOperate',
        component: doorOperate
    },
    // 机房门禁开关
    {
        path: '/doorSwitch',
        component: doorSwitch
    },
    /*提交工单*/
    {
        path: '/newOrder',
        component: newOrder
    },
    /*电能统计*/
    {
        path: '/energyStatistics',
        component: energyStatistics
    }
    
    ]
});

//Vuex配置
const store = new Vuex.Store({
    state: {
        terminalId:4,//当前终端id
//      APP同PC共同接口
        domain:window.location.href.replace(/\/#/g,'').replace(/:18080.*$/g,'').replace(/localhost/,'192.168.1.145').replace(/www.landesker.com.*$/g,'47.98.150.37') + ':20080/index.php',
//      PC接口
        domain2:window.location.href.replace(/\/#/g,'').replace(/:18080.*$/g,'').replace(/localhost/,'192.168.1.145').replace(/www.landesker.com.*$/g,'47.98.150.37') + ':20086',
//      图片地址
        domain3:window.location.href.replace(/\/#/g,'').replace(/:18080.*$/g,':18080').replace(/localhost/,'192.168.1.145').replace(/www.landesker.com.*$/g,'47.98.150.37')
         + '/static/img/',
        // 初始化用户信息
        originalUserInfo: {
            real_name: '',
            administrators: '',
            username: '',
            token:'',
            uid:'',
            company_id:'',
        },
        userInfo: { //保存用户信息
            real_name: '',
            administrators: '',
            username: '',
            token:'',
            uid:'',
            company_id:'',
        }
    },
    mutations: {
        //更新用户信息
        updateUserInfo(state, newUserInfo) {
            state.userInfo = newUserInfo;
        }
       
    }
});



//设置cookie,增加到vue实例方便全局调用
//vue全局调用的理由是，有些组件所用到的接口可能需要session验证，session从cookie获取
//当然，如果session保存到vuex的话除外
Vue.prototype.setCookie = (c_name, value, expiredays) => {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString());
};

//获取cookie、
var getCookie=function (name){
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg))
    return unescape(arr[2]);
  else
    return null;
};

Vue.prototype.getCookie = getCookie;

//删除cookie
Vue.prototype.delCookie =(name) => {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = getCookie(name);
    if (cval != null)
      document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
};

//签名算法
Vue.prototype.sign = function(obj) {
	var signObject=function(parentName,obj){
      var strSign='';
			names = Object.keys(obj).sort();
			var valueType,value;
			for (j = 0; j < names.length; j++) {
				name = names[j];
				value = obj[name];
				valueType=typeof value;
				if('object'===valueType){
				    strSign+=signObject(parentName+'.'+name,value);
				    continue;
				}
				strSign += parentName + '.' + name + value;
			}
			return strSign;
	};
	var token = this.getCookie('token') ? this.getCookie('token') : null;
	/*console.log('token:'+token)*/
	if (token === null) {
		return '';
	}
	//var account = $store.account ? $store.account : {};
	//obj.machineRoomId = $store.machineRoomId ? $store.machineRoomId : 1;
	//obj.accountId = account.accountId ? account.accountId : 0;
	var params = Object.keys(obj).sort(), pValue, names, name, pName, pValueType,
		j;
	var strSign = '';
	for (var i = 0; i < params.length; i++) {
		pName = params[i];
		pValue = obj[pName];
		pValueType = typeof pValue;
		if ('sign' === pName || pValue === undefined || pValue === null || pValue === 'null') {
			delete obj[pName];
			continue;
		}
		if ('object' === pValueType) {//支持嵌套对象
			strSign+=signObject(pName,pValue);
			continue;
		}
		strSign += pName + pValue;
	}
	obj.sign = sha256.hmac(token,strSign);
//	 console.log('str:' + strSign);
//	 console.log('key:' + token);
//	 console.log('sign:' + obj.sign);
}

//签名算法2
Vue.prototype.sign2 = function(myJson) {
		//console.log('进入方法');
		var sign = '';
		var strSign = '';
		for(var p in myJson){//遍历json对象的每个key/value对,p为key
 			strSign=strSign+myJson[p];
		}
		strSign = 'landesker_' +strSign + '_landesker';
		// console.log(strSign);
		myJson.sign = sha256(strSign);
		//console.log(myJson);
}
//表格时间戳转换为YYYY-MM-DD格式
Vue.prototype.dateFormat = function (row, column) {
    if (row && column) {
        var date = row[column.property];
        if (date == undefined || date === 0) {
            return "--";
        }
        return moment(date * 1000).format("YYYY-MM-DD");
    }
}
//非表格时间戳转换为YYYY-MM-DD HH:MM:SS格式
Vue.prototype.dateFormat2 = function (value) {
    if (value) {
        var date = value;
        if (date == undefined) {
            return "";
        }
        return moment(date * 1000).format('YYYY-MM-DD HH:mm:ss');
    }

}
//表格时间戳转换为YYYY-MM-DD HH:MM:SS格式
Vue.prototype.dateFormatThree = function (row, column) {
    if (row && column) {
        var date = row[column.property];
        if (date == undefined || date === 0) {
            return "--";
        }
        return moment(date * 1000).format("YYYY-MM-DD HH:mm:ss");
    }
}

//提取汉字,并把,换成/
Vue.prototype.GetChinese = function (strValue) {
    if (strValue != null && strValue != "") {
        var reg = /[\u4e00-\u9fa5^\,]/g;
        return "可填写告警值: " + strValue.match(reg).join("").replace(/\,/g, '\/');
    }
    else {
        return "";
    }

}

//非表格时间戳转换为YYYY-MM-DD格式
Vue.prototype.dateFormat3 = function (value) {
    if (value) {
        var date = value;
        if (date == undefined) {
            return "";
        }
        return moment(date * 1000).format("YYYY-MM-DD");
    }

}
//返回时间戳距离当天天数
Vue.prototype.deadLineDays = function (value) {
    if (value) {
        var date = value;
        if (date == undefined) {
            return "";
        }
        var remain = date - Date.parse(new Date()) / 1000;
        if (remain && remain > 0) {
            return parseInt(remain / 60 / 60 / 24) + "天";
        } else {
            return "已过期";

        }

    } else {
        return "已过期";
    }

}
//设备类型转换为汉字
Vue.prototype.deviceTypeFormat = function (row, column) {

    if (row.device_type == undefined) {
        return "";
    } else {
        if (row.device_type == "LDSK") {
            return "网关盒"
        } else if (row.device_type == "LDSKPRO") {
            return "网关盒PRO"
        } else if (row.device_type == "FLOOR") {
            return "地板网关"
        } else if (row.device_type == "AIIOT485") {
            return "迷你网关"
        } else {
            return "移动数据中心"
        }
    }
}
//设备类型转换为汉字2 网关用途 1:机柜2:动力3:环境
Vue.prototype.deviceTypeFormat2 = function (row) {
    if (row.category && row.category == 1) {
        return "机柜"
    } else if (row.category == 2) {
        return "动力"
    } else if (row.category == 3) {
        return "环境"
    } else {
        return ""
    }

}
//门禁是否启用访问方式转换为汉字
Vue.prototype.doorSwitchFormat = function (row) {

    if (row.door_status == row.logic_close_value) {
        return "禁用";
    } else if (row.door_status == row.logic_open_value) {
        return "启用";
    } else {
        return "";
    }
}
//指纹门禁访问方式转换为汉字
Vue.prototype.visitWay = function (row, column) {

    if (row.mode == undefined) {
        return "";
    } else {
        if (row.mode == "1") {
            return "指纹"
        } else if (row.mode == "2") {
            return "卡"
        } else {
            return "密码"
        }

    }

}
//指纹门禁访问方式转换为汉字2 0~9指纹10:密码11:卡
Vue.prototype.visitWay2 = function (row, column) {

    if (row.backupnum == undefined) {
        return "";
    } else {
        if (row.backupnum == "10") {
            return "密码"
        } else if (row.backupnum == "11") {
            return "卡"
        } else {
            return "指纹" + row.backupnum
        }

    }

}
//返回状态转换为汉字
Vue.prototype.ifActive = function (row, column) {

    if (row.status == undefined) {
        return "";
    } else {
        if (row.status == "0") {
            return "未激活"
        } else {
            return "已激活"
        }
    }

}
//返回紧急状态转换为汉字
Vue.prototype.forUrgent = function (row, column) {

    if (row.urgent == undefined) {
        return "";
    } else {
        if (row.urgent == "1") {
            return "一般"
        } else {
            return "重要"
        }
    }

}
//字符串转换
Vue.prototype.forUrgent2 = function (value) {
    if (value) {
        if (value == '2') {
            return "重要"
        } else {
            return "一般"
        }
    }

}
//返回状态转换为汉字情况二
Vue.prototype.ifActive2 = function (row, column) {

    if (row.status == undefined) {
        return "";
    } else {
        if (row.status == "0") {
            return "禁用"
        } else {
            return "可用"
        }
    }

}
//指纹识别人员列表转换身份
Vue.prototype.userToChart = function (row, column) {

    if (row.admin == undefined) {
        return "";
    } else {
        if (row.admin == "1") {
            return "管理员"
        } else if (row.admin == "2") {
            return "超级管理员"
        } else {
            return "普通用户"
        }
    }

}
Vue.prototype.ifActive22 = function (value) {

    if (value == undefined) {
        return "";
    } else {
        if (value == "0") {
            return "禁用"
        } else {
            return "可用"
        }
    }

}
//返回状态转换为汉字情况三
Vue.prototype.ifActive3 = function (row, column) {

    if (row.status == undefined) {
        return "11";
    } else {
        if (row.status == "1") {
            return "禁用"
        } else {
            return "可用"
        }
    }

}
//工单状态转换文字
Vue.prototype.formatOrder = function (row, column) {

    if (row.state == undefined) {
        return "";
    } else {
        if (row.state == "N") {
            return "新建"
        } else if (row.state == "C") {
            return "通知中"
        } else if (row.state == "D") {
            return "处理中"
        } else if (row.state == "S") {
            return "发送失败"
        } else {
            return "已完成"
        }
    }

}
//通讯状态转汉字
Vue.prototype.formatTerStatus = function (value) {
    switch (parseInt(value)) {
        case 1:
            return "已激活";
        case 2:
            return "已过期";
        case 3:
            return "离线";
        default:
            return "异常"

    }
},

//菜单类别转汉字
//工单状态转换文字
Vue.prototype.formatMenuType = function (row, column) {

    if (row.type == undefined) {
        return "";
    } else {
        if (row.type == 1) {
            return "菜单"
        } else {
            return "按钮"
        }
    }

}


    //验证码倒计时
    Vue.prototype.sendMsg = function () {
        let me = this;
        me.isDisabled = true;
        let interval = window.setInterval(function () {
            me.buttonName = me.time + '秒后重新发送';
            --me.time;
            if (me.time < 0) {
                me.buttonName = "重新发送";
                me.time = 60;
                me.isDisabled = false;
                window.clearInterval(interval);
            }
        }, 1000);

    }

// Vue.http.headers['Content-Type']='application/x-www-form-urlencoded';
//vue实例
var app = new Vue({
    data: {},
    el: '#app',
    render: h => h(App),
    router,
    store,
    watch:{
        "$route" : 'checkLogin'
    },
    created() {
        this.checkLogin();
    },
    methods:{
        checkLogin(){
        	if(!this.getCookie('username') && this.$route.path!="/register" && this.$route.path!="/findpass"){
		        //如果没有登录状态则跳转到登录页
		        this.$router.push('/login');
		      }else{
		      	let userInfo= { //保存用户信息
				        real_name: this.getCookie('real_name'),
				        token: this.getCookie('token'),
				        accountId: this.getCookie('accountId'),
				        administrators: this.getCookie('administrators'),
				        username: this.getCookie('username'),
				        company_id: this.getCookie('company_id'),
				    }
		      	this.$store.commit('updateUserInfo', userInfo);
		      }
        }
    }
});




// WEBPACK FOOTER //
// ./src/main.js